import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-excelhealth-components',
  template: `
    <p>
      excelhealth-components works!
    </p>
  `,
  styles: []
})
export class ExcelhealthComponentsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
